import { t } from 'ember-intl';
import NavTabs from 'tio-ui/components/nav-tabs';
import PageHero from 'tio-ui/components/page-hero';
import { PhPiggyBank } from 'ember-phosphor-icons';
import { Section, VStack } from 'tio-ui/components/layout';

<template>
  <VStack>
    <PageHero
      @gradient="brand-soft"
      class="tio-elevation-card-raised"
      @icon={{PhPiggyBank}}
      @title={{t "planning_for_college.five_two_nine.what_is_529_title"}}
      @subtitle={{t "planning_for_college.five_two_nine.what_is_529_text"}}
    />
    <Section>
      <:body>
        <div class="tio-flex-center flex-col">
          <img
            class="w-full max-w-48 m-6 self-center"
            alt={{t "planning_for_college.five_two_nine.saving_for_college_alt"}}
            src="/assets/images/planning-for-college/logo-sfc.png"
          />
          <div class="w-full max-w-screen-sm self-center text-center tio-fg-muted app-rich-text">
            {{t "planning_for_college.five_two_nine.saving_for_college" htmlSafe=true}}
          </div>
        </div>
        <NavTabs
          @tabs={{array
            (hash label="Benefits" route="authenticated.planning-for-college.529-tools.index")
            (hash
              label="Savings Over Time" route="authenticated.planning-for-college.529-tools.savings"
            )
            (hash label="FAQs" route="authenticated.planning-for-college.529-tools.faqs")
          }}
        />

        <VStack>
          {{outlet}}

          <div class="text-xs mt-10 tio-fg-disabled leading-5">
            <div class="uppercase">
              {{t "planning_for_college.five_two_nine.disclaimer_title"}}
            </div>
            <div>
              {{t "planning_for_college.five_two_nine.disclaimer_text"}}
            </div>
          </div>
        </VStack>
      </:body>
    </Section>
  </VStack>
</template>
